// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("sprite.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pt-icon-svg {
  display: inline-block;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.pt-sustainability-wheel {
  width: 32px;
  height: 32px;
  background-position: 0 0;
}
.pt-weather--1 {
  width: 32px;
  height: 32px;
  background-position: -48px 0;
}
.pt-weather--2 {
  width: 32px;
  height: 32px;
  background-position: -96px 0;
}
.pt-weather--3 {
  width: 32px;
  height: 32px;
  background-position: -144px 0;
}
.pt-weather-0 {
  width: 32px;
  height: 32px;
  background-position: -192px 0;
}
.pt-weather-1 {
  width: 32px;
  height: 32px;
  background-position: -240px 0;
}
.pt-weather-2 {
  width: 32px;
  height: 32px;
  background-position: -288px 0;
}
.pt-weather-3 {
  width: 32px;
  height: 32px;
  background-position: -336px 0;
}
.pt-weather-4 {
  width: 32px;
  height: 32px;
  background-position: -384px 0;
}
.pt-weather-5 {
  width: 32px;
  height: 32px;
  background-position: -432px 0;
}
.pt-weather-6 {
  width: 32px;
  height: 32px;
  background-position: -480px 0;
}
.pt-weather-7 {
  width: 32px;
  height: 32px;
  background-position: -528px 0;
}
.pt-weather-8 {
  width: 32px;
  height: 32px;
  background-position: -576px 0;
}
.pt-weather-9 {
  width: 32px;
  height: 32px;
  background-position: -624px 0;
}
.pt-weather-10 {
  width: 32px;
  height: 32px;
  background-position: -672px 0;
}
.pt-weather-11 {
  width: 32px;
  height: 32px;
  background-position: -720px 0;
}
.pt-weather-12 {
  width: 32px;
  height: 32px;
  background-position: 0 -48px;
}
.pt-weather-13 {
  width: 32px;
  height: 32px;
  background-position: -48px -48px;
}
.pt-weather-14 {
  width: 32px;
  height: 32px;
  background-position: -96px -48px;
}
.pt-weather-15 {
  width: 32px;
  height: 32px;
  background-position: -144px -48px;
}
.pt-weather-16 {
  width: 32px;
  height: 32px;
  background-position: -192px -48px;
}
.pt-weather-17 {
  width: 32px;
  height: 32px;
  background-position: -240px -48px;
}
.pt-weather-18 {
  width: 32px;
  height: 32px;
  background-position: -288px -48px;
}
.pt-weather-19 {
  width: 32px;
  height: 32px;
  background-position: -336px -48px;
}
.pt-weather-20 {
  width: 32px;
  height: 32px;
  background-position: -384px -48px;
}
.pt-weather-21 {
  width: 32px;
  height: 32px;
  background-position: -432px -48px;
}
.pt-weather-22 {
  width: 32px;
  height: 32px;
  background-position: -480px -48px;
}
.pt-weather-23 {
  width: 32px;
  height: 32px;
  background-position: -528px -48px;
}
.pt-weather-24 {
  width: 32px;
  height: 32px;
  background-position: -576px -48px;
}
.pt-weather-25 {
  width: 32px;
  height: 32px;
  background-position: -624px -48px;
}
.pt-weather-26 {
  width: 32px;
  height: 32px;
  background-position: -672px -48px;
}
.pt-weather-27 {
  width: 32px;
  height: 32px;
  background-position: -720px -48px;
}
.pt-weather-28 {
  width: 32px;
  height: 32px;
  background-position: 0 -96px;
}
.pt-weather-29 {
  width: 32px;
  height: 32px;
  background-position: -48px -96px;
}
.pt-weather-30 {
  width: 32px;
  height: 32px;
  background-position: -96px -96px;
}
.pt-weather-31 {
  width: 32px;
  height: 32px;
  background-position: -144px -96px;
}
.pt-weather-32 {
  width: 32px;
  height: 32px;
  background-position: -192px -96px;
}
.pt-weather-33 {
  width: 32px;
  height: 32px;
  background-position: -240px -96px;
}
.pt-weather-34 {
  width: 32px;
  height: 32px;
  background-position: -288px -96px;
}
.pt-weather-35 {
  width: 32px;
  height: 32px;
  background-position: -336px -96px;
}
.pt-weather-36 {
  width: 32px;
  height: 32px;
  background-position: -384px -96px;
}
.pt-weather-37 {
  width: 32px;
  height: 32px;
  background-position: -432px -96px;
}
.pt-weather-38 {
  width: 32px;
  height: 32px;
  background-position: -480px -96px;
}
.pt-weather-39 {
  width: 32px;
  height: 32px;
  background-position: -528px -96px;
}
.pt-weather-40 {
  width: 32px;
  height: 32px;
  background-position: -576px -96px;
}
.pt-weather-41 {
  width: 32px;
  height: 32px;
  background-position: -624px -96px;
}
.pt-weather-42 {
  width: 32px;
  height: 32px;
  background-position: -672px -96px;
}
.pt-weather-43 {
  width: 32px;
  height: 32px;
  background-position: -720px -96px;
}
.pt-weather-44 {
  width: 32px;
  height: 32px;
  background-position: 0 -144px;
}
.pt-weather-45 {
  width: 32px;
  height: 32px;
  background-position: -48px -144px;
}
.pt-weather-46 {
  width: 32px;
  height: 32px;
  background-position: -96px -144px;
}
.pt-weather-47 {
  width: 32px;
  height: 32px;
  background-position: -144px -144px;
}
.pt-weather-na {
  width: 32px;
  height: 32px;
  background-position: -192px -144px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Icon/sprite/sprite.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,yDAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC","sourcesContent":[".pt-icon-svg {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-image: url(sprite.svg);\n}\n.pt-sustainability-wheel {\n  width: 32px;\n  height: 32px;\n  background-position: 0 0;\n}\n.pt-weather--1 {\n  width: 32px;\n  height: 32px;\n  background-position: -48px 0;\n}\n.pt-weather--2 {\n  width: 32px;\n  height: 32px;\n  background-position: -96px 0;\n}\n.pt-weather--3 {\n  width: 32px;\n  height: 32px;\n  background-position: -144px 0;\n}\n.pt-weather-0 {\n  width: 32px;\n  height: 32px;\n  background-position: -192px 0;\n}\n.pt-weather-1 {\n  width: 32px;\n  height: 32px;\n  background-position: -240px 0;\n}\n.pt-weather-2 {\n  width: 32px;\n  height: 32px;\n  background-position: -288px 0;\n}\n.pt-weather-3 {\n  width: 32px;\n  height: 32px;\n  background-position: -336px 0;\n}\n.pt-weather-4 {\n  width: 32px;\n  height: 32px;\n  background-position: -384px 0;\n}\n.pt-weather-5 {\n  width: 32px;\n  height: 32px;\n  background-position: -432px 0;\n}\n.pt-weather-6 {\n  width: 32px;\n  height: 32px;\n  background-position: -480px 0;\n}\n.pt-weather-7 {\n  width: 32px;\n  height: 32px;\n  background-position: -528px 0;\n}\n.pt-weather-8 {\n  width: 32px;\n  height: 32px;\n  background-position: -576px 0;\n}\n.pt-weather-9 {\n  width: 32px;\n  height: 32px;\n  background-position: -624px 0;\n}\n.pt-weather-10 {\n  width: 32px;\n  height: 32px;\n  background-position: -672px 0;\n}\n.pt-weather-11 {\n  width: 32px;\n  height: 32px;\n  background-position: -720px 0;\n}\n.pt-weather-12 {\n  width: 32px;\n  height: 32px;\n  background-position: 0 -48px;\n}\n.pt-weather-13 {\n  width: 32px;\n  height: 32px;\n  background-position: -48px -48px;\n}\n.pt-weather-14 {\n  width: 32px;\n  height: 32px;\n  background-position: -96px -48px;\n}\n.pt-weather-15 {\n  width: 32px;\n  height: 32px;\n  background-position: -144px -48px;\n}\n.pt-weather-16 {\n  width: 32px;\n  height: 32px;\n  background-position: -192px -48px;\n}\n.pt-weather-17 {\n  width: 32px;\n  height: 32px;\n  background-position: -240px -48px;\n}\n.pt-weather-18 {\n  width: 32px;\n  height: 32px;\n  background-position: -288px -48px;\n}\n.pt-weather-19 {\n  width: 32px;\n  height: 32px;\n  background-position: -336px -48px;\n}\n.pt-weather-20 {\n  width: 32px;\n  height: 32px;\n  background-position: -384px -48px;\n}\n.pt-weather-21 {\n  width: 32px;\n  height: 32px;\n  background-position: -432px -48px;\n}\n.pt-weather-22 {\n  width: 32px;\n  height: 32px;\n  background-position: -480px -48px;\n}\n.pt-weather-23 {\n  width: 32px;\n  height: 32px;\n  background-position: -528px -48px;\n}\n.pt-weather-24 {\n  width: 32px;\n  height: 32px;\n  background-position: -576px -48px;\n}\n.pt-weather-25 {\n  width: 32px;\n  height: 32px;\n  background-position: -624px -48px;\n}\n.pt-weather-26 {\n  width: 32px;\n  height: 32px;\n  background-position: -672px -48px;\n}\n.pt-weather-27 {\n  width: 32px;\n  height: 32px;\n  background-position: -720px -48px;\n}\n.pt-weather-28 {\n  width: 32px;\n  height: 32px;\n  background-position: 0 -96px;\n}\n.pt-weather-29 {\n  width: 32px;\n  height: 32px;\n  background-position: -48px -96px;\n}\n.pt-weather-30 {\n  width: 32px;\n  height: 32px;\n  background-position: -96px -96px;\n}\n.pt-weather-31 {\n  width: 32px;\n  height: 32px;\n  background-position: -144px -96px;\n}\n.pt-weather-32 {\n  width: 32px;\n  height: 32px;\n  background-position: -192px -96px;\n}\n.pt-weather-33 {\n  width: 32px;\n  height: 32px;\n  background-position: -240px -96px;\n}\n.pt-weather-34 {\n  width: 32px;\n  height: 32px;\n  background-position: -288px -96px;\n}\n.pt-weather-35 {\n  width: 32px;\n  height: 32px;\n  background-position: -336px -96px;\n}\n.pt-weather-36 {\n  width: 32px;\n  height: 32px;\n  background-position: -384px -96px;\n}\n.pt-weather-37 {\n  width: 32px;\n  height: 32px;\n  background-position: -432px -96px;\n}\n.pt-weather-38 {\n  width: 32px;\n  height: 32px;\n  background-position: -480px -96px;\n}\n.pt-weather-39 {\n  width: 32px;\n  height: 32px;\n  background-position: -528px -96px;\n}\n.pt-weather-40 {\n  width: 32px;\n  height: 32px;\n  background-position: -576px -96px;\n}\n.pt-weather-41 {\n  width: 32px;\n  height: 32px;\n  background-position: -624px -96px;\n}\n.pt-weather-42 {\n  width: 32px;\n  height: 32px;\n  background-position: -672px -96px;\n}\n.pt-weather-43 {\n  width: 32px;\n  height: 32px;\n  background-position: -720px -96px;\n}\n.pt-weather-44 {\n  width: 32px;\n  height: 32px;\n  background-position: 0 -144px;\n}\n.pt-weather-45 {\n  width: 32px;\n  height: 32px;\n  background-position: -48px -144px;\n}\n.pt-weather-46 {\n  width: 32px;\n  height: 32px;\n  background-position: -96px -144px;\n}\n.pt-weather-47 {\n  width: 32px;\n  height: 32px;\n  background-position: -144px -144px;\n}\n.pt-weather-na {\n  width: 32px;\n  height: 32px;\n  background-position: -192px -144px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
